document.addEventListener('DOMContentLoaded', function () {
  var suppressNextClick = false;

  document.querySelectorAll('product-modal.media-modal').forEach(function (modal) {
    var content = modal.querySelector('.product-media-modal__content');
    var nav = modal.querySelector('[data-lightbox-nav]');
    if (!content || !nav) return;

    var prevBtn = nav.querySelector('[data-lightbox-prev]');
    var nextBtn = nav.querySelector('[data-lightbox-next]');
    var currentEl = nav.querySelector('[data-lightbox-current]');
    var totalEl = nav.querySelector('[data-lightbox-total]');

      // Mapa: id zdjęcia -> [grupa koloru, kolejność] (z product-media-modal.liquid)
    var groups = {};
    var groupsEl = modal.querySelector('[data-lightbox-groups]');
    if (groupsEl) {
      try { groups = JSON.parse(groupsEl.textContent); } catch (e) { groups = {}; }
    }

    function info(el) {
      return groups[el.getAttribute('data-media-id')] || null;
    }

    // Zdjęcia tylko z koloru aktualnie otwartego zdjęcia, w kolejności z panelu Shopify
    function getItems() {
      var all = Array.prototype.filter.call(content.children, function (el) {
        return el.hasAttribute('data-media-id');
      });
      var active = all.filter(function (el) { return el.classList.contains('active'); })[0];
      var activeInfo = active ? info(active) : null;
      if (!activeInfo) return all;

      return all
        .filter(function (el) {
          var i = info(el);
          return i && i[0] === activeInfo[0];
        })
        .sort(function (a, b) {
          return info(a)[1] - info(b)[1];
        });
    }

    function getIndex(items) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('active')) return i;
      }
      return 0;
    }

    // Wczytuje z wyprzedzeniem sąsiednie zdjęcia, żeby przesuwanie było płynne
    function preload(items, i) {
      [i - 1, i + 1].forEach(function (n) {
        var el = items[(n + items.length) % items.length];
        if (el && el.tagName === 'IMG') el.loading = 'eager';
      });
    }

    function update() {
      var items = getItems();
      var i = getIndex(items);
      currentEl.textContent = i + 1;
      totalEl.textContent = items.length;
      nav.hidden = items.length < 2;
      preload(items, i);
    }

    function go(step) {
      var items = getItems();
      if (items.length < 2) return;
      var i = getIndex(items);
      var target = items[(i + step + items.length) % items.length];

      items[i].classList.remove('active', 'lightbox-in-next', 'lightbox-in-prev');
      target.classList.remove('lightbox-in-next', 'lightbox-in-prev');
      void target.offsetWidth; // restart animacji
      target.classList.add('active', step > 0 ? 'lightbox-in-next' : 'lightbox-in-prev');

      if (window.pauseAllMedia) window.pauseAllMedia();
      update();
    }

    content.addEventListener('animationend', function (e) {
      e.target.classList.remove('lightbox-in-next', 'lightbox-in-prev');
    });

    // Licznik przy każdym otwarciu powiększenia
    new MutationObserver(function () {
      if (modal.hasAttribute('open')) update();
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    // Strzałki
    prevBtn.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    nextBtn.addEventListener('click', function (e) { e.preventDefault(); go(1); });

    // Kliknięcie w strzałki/licznik nie zamyka powiększenia (motyw zamyka je każdym kliknięciem myszy)
    nav.addEventListener('pointerup', function (e) { e.stopPropagation(); });

    // Klawiatura: strzałki lewo/prawo
    modal.addEventListener('keydown', function (e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });

    // Dotyk: przesunięcie palcem = zmiana zdjęcia, krótkie stuknięcie = zamknięcie
    var startX = 0, startY = 0, startT = 0, tracking = false, multi = false;

    modal.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1) { multi = true; return; }
      multi = false;
      tracking = !e.target.closest('[data-lightbox-nav], [id^="ModalClose-"], deferred-media, product-model');
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startT = Date.now();
    }, { passive: true });

    modal.addEventListener('touchmove', function (e) {
      if (e.touches.length > 1) multi = true;
    }, { passive: true });

    modal.addEventListener('touchend', function (e) {
      if (!tracking || e.touches.length > 0) return;
      tracking = false;
      if (multi) return; // to był pinch-zoom

      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      var zoomed = window.visualViewport && window.visualViewport.scale > 1.05;

      if (!zoomed && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        go(dx < 0 ? 1 : -1);
        return;
      }

      if (Math.abs(dx) < 10 && Math.abs(dy) < 10 && Date.now() - startT < 400) {
        e.preventDefault(); // blokuje "click-ducha" pod spodem
        suppressNextClick = true;
        modal.hide();
        setTimeout(function () { suppressNextClick = false; }, 500);
      }
    });
  });

  // Siatka bezpieczeństwa: blokuje spóźniony "click-duch" po zamknięciu dotykiem
  document.addEventListener('click', function (event) {
    if (suppressNextClick) {
      event.preventDefault();
      event.stopPropagation();
      suppressNextClick = false;
    }
  }, true);
});